import { render, staticRenderFns } from "./merchantSurchargeManagement.vue?vue&type=template&id=35c740da&scoped=true&"
import script from "./merchantSurchargeManagement.vue?vue&type=script&lang=js&"
export * from "./merchantSurchargeManagement.vue?vue&type=script&lang=js&"
import style0 from "./merchantSurchargeManagement.vue?vue&type=style&index=0&id=35c740da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c740da",
  null
  
)

export default component.exports